// extracted by mini-css-extract-plugin
module.exports = {"footer":"SelectPeriod_footer__22rht"};